import uniqBy from 'lodash.uniqby'

export default function getFormFields(
  response: IProjectFlow[] | undefined,
  {
    shouldIncludeAssignmentLevelKeys,
    shouldRemoveKeysWithoutDisplayType
  }: {
    shouldIncludeAssignmentLevelKeys?: boolean
    shouldRemoveKeysWithoutDisplayType?: boolean
  } = {
    shouldIncludeAssignmentLevelKeys: true,
    shouldRemoveKeysWithoutDisplayType: true
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] {
  if (!Array.isArray(response)) return []
  if (response.some(_response => typeof _response === 'undefined')) return []

  const validJson = response
    .map((jsonForStep, stepIndex) => {
      // index is 1 for assignment step in the json, but only after filtering the json by account type
      return stepIndex !== 1 || shouldIncludeAssignmentLevelKeys
        ? jsonForStep.body
        : []
    })
    .flat()

  const fields = validJson
    .filter(Boolean)
    .map(bodyJsonObject => bodyJsonObject.group.dataset)
    .flat() // After this step, we have a flat array of objects for each field
    .map(fieldJson => {
      if (Array.isArray(fieldJson.body)) {
        return [fieldJson, ...fieldJson.body]
      }
      return fieldJson
    })
    .flat() // After this step, we have a flat array of objects for each field, including nested body fields
    .map(fieldJson => {
      if (!fieldJson.subId) return fieldJson
      const subIdFieldJson = {
        ...fieldJson,
        id: fieldJson.subId,
        dataType: fieldJson.subDataType,
        displayType: 'multiBlockSelect', // TODO: handle this properly instead of hardcoding
        label: fieldJson.subLabel || `${fieldJson.label} - Selected Items`,
        options: fieldJson.templateOptions
          .map((tOption: { options: unknown[] }) => tOption.options)
          .flat() // TODO: Make this generic in terms of  optionsKey instead of hardcoding templateOptions
      }
      delete subIdFieldJson.templateOptions
      return [fieldJson, subIdFieldJson]
    })
    .flat() // After this step, we have a flat array of objects for each field, including separate object for subId fields
    .filter(_response => !['project_title'].includes(_response.id))
    .filter(
      _response => !shouldRemoveKeysWithoutDisplayType || _response.displayType
    )
    .map(_response => {
      if (
        Array.isArray(_response.validation) &&
        _response.validation.findIndex(
          (validation: { type: string; params: string[] }) =>
            validation.type === 'required'
        ) !== -1
      ) {
        return {
          ..._response,
          required: true
        }
      }

      return _response
    })

  return uniqBy(fields, 'id')
}
